import {useRequest} from '@aboutyou/data-fetcher';
import {useHydrationDone} from '@aboutyou/lazy-imports';

const IS_APP_INSTALLED_REQUEST_KEY = 'IS_APP_INSTALLED_REQUEST_KEY';

/**
 * Returns a boolean to check if the app is installed or not in the device.
 *
 * Please note: due to technical limitations this hook doesn't work on iOS, since the getInstalledRelatedApps is not available on iOS + Safari navigator.
 */
export function useIsAppInstalled() {
  const isHydrationDone = useHydrationDone();

  const {data, isLoading} = useRequest<{
    isInstalled: boolean;
  }>(
    IS_APP_INSTALLED_REQUEST_KEY,
    async () => {
      if ('navigator' in globalThis && 'getInstalledRelatedApps' in navigator) {
        const isInstalled =
          // @ts-ignore
          (await navigator.getInstalledRelatedApps()).length > 0;
        return {isInstalled};
      }
      return {isInstalled: false};
    },
    {
      keepPreviousData: false,
      disabled: !isHydrationDone,
    },
  );

  return {
    isInstalled: data?.isInstalled ?? false,
    isLoading: !isHydrationDone ? false : isLoading,
  };
}
